import Axios from 'axios'

import {Notification} from 'element-ui'
import {Loading} from 'element-ui';
import router from './router'

const http = Axios.create({
    // baseURL: 'http://192.168.8.9:8001/',
    baseURL: 'http://47.97.60.182:9001/',
    headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    timeout: 30 * 1000,
    validateStatus: (status) => {
        return status === 200;
    },
});

let loading;
let needLoadingRequestCount = 0;

http.interceptors.request.use(
    config => {
        loading = Loading.service({
            lock: true,
            text: "加载中...",
            background: "rgba(0, 0, 0, 0.8)",
        });
        needLoadingRequestCount++;
        return config
    },
    error => Promise.error(error),
);

http.interceptors.response.use(
    response => {
        if (needLoadingRequestCount <= 0) {
            return response.data;
        }
        needLoadingRequestCount--;
        if (needLoadingRequestCount == 0) {
            loading.close();
        }
        if (response.data.Code == 1018 || response.data.Code == 1000) {
            //Notification.error('登录过期，请重新登录');
            router.replace('/');
        }
        return response.data;
    },
    error => {
        const {response} = error;
        if (response) {
            needLoadingRequestCount--;
            loading.close();
            switch (response.status) {
                case 401:
                    Notification.error('请登录');
                    break;
                case 403:
                    Notification.error('登录过期，请重新登录');
                    break;
                case 404:
                    Notification.error('请求的资源不存在');
                    loading.close();
                    break;
                default:
                    console.log(response)
            }
            loading.close();
            return Promise.reject(response)
        } else {
            needLoadingRequestCount--;
            loading.close();
            Notification.error('请求超时');
        }
        return Promise.reject(error);
    },
);

export default http
